import { get as lodashGet } from 'lodash'
import NotificationApi from '@/api/notification'
import sentry from '@/services/sentry'

const SET_NOTIFICATION_STATE = 'SET_NOTIFICATION_STATE'
const SET_NOTIFICATION_LOADING = 'SET_NOTIFICATION_LOADING'
const ITEMS_PER_PAGE = 40

const _state = {
  notifications: [],
  currentPage: 0,
  isLoading: false,
  totalItems: 0,
  totalPages: 0,
}

const services = {
  async getNotifications(numberOfUsersPerPage, page) {
    return NotificationApi.getNotifications({
      numberOfUsersPerPage, page,
    }).then((rs) => {
      const pages = lodashGet(rs, 'pages', 1)
      const total = lodashGet(rs, 'count', 0)
      const notifications = lodashGet(rs, 'result', 1)
      return {
        pages, total, notifications,
      }
    })
  },
}

const getters = {
  notifications: (state) => state.notifications,
  isLastPage: (state) => state.currentPage >= state.totalPages,
  isLoading: (state) => state.isLoading,
}

const actions = {
  async getNotificationsAction({ commit, state }) {
    try {
      const currentPage = state.currentPage + 1
      commit(SET_NOTIFICATION_LOADING, true)
      const { pages, total, notifications } = await services.getNotifications(ITEMS_PER_PAGE, currentPage)
      commit(SET_NOTIFICATION_STATE, {
        notifications, total, pages, currentPage,
      })
    } catch (e) {
      sentry.captureException(e)
    } finally {
      commit(SET_NOTIFICATION_LOADING, false)
    }
  },
}

const mutations = {
  [SET_NOTIFICATION_STATE](state, {
    notifications, total, pages, currentPage,
  }) {
    state.notifications = [...state.notifications, ...notifications]
    state.totalItems = total
    state.totalPages = pages
    state.currentPage = currentPage
  },
  [SET_NOTIFICATION_LOADING](state, isLoading) {
    state.isLoading = isLoading
  },
}

const notification = {
  namespaced: true,
  state: _state,
  getters,
  actions,
  mutations,
}

export default notification
